import Glide from '@glidejs/glide';
import '@glidejs/glide/dist/css/glide.core.min.css';
export function setUpCarousels() {
    document.querySelectorAll('.glide').forEach(div => {
        div.querySelectorAll('.glide__slide').forEach(x => x.classList.remove('hidden'));
        // Using ts-ignore because types on GlideJS are wrong,
        // you can pass an HTMLElement in here and not just a selector string.
        // @ts-ignore
        let carousel = new Glide(div, {
            type: 'carousel'
        });
        // Fix tab order by setting `tabindex` attribute on load and every action
        carousel.on("mount.after", () => {
            div.querySelector(".glide__slide--active a").setAttribute("tabindex", "0");
        });
        carousel.on('run.before', () => {
            div.querySelector(".glide__slide--active a").setAttribute("tabindex", "-1");
        });
        carousel.on('run.after', () => {
            div.querySelector(".glide__slide--active a").setAttribute("tabindex", "0");
        });
        carousel.mount();
    });
}
